import BoardPerformanceTabsQuery from '@jira/admin-pages__performance/src/__generated__/BoardPerformanceTabsQuery.graphql.ts';
import PerformanceNetworkViewQuery from '@jira/admin-pages__performance/src/__generated__/PerformanceNetworkViewQuery.graphql';
import metricsOverviewQuery from '@jira/admin-pages__performance/src/__generated__/PerformanceOverviewMainQuery.graphql';
import PerformanceOverviewQuery from '@jira/admin-pages__performance/src/__generated__/PerformanceOverviewQuery.graphql';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { fg } from '@atlassian/jira-feature-gating';

export const PerformanceMonitorDashboardEntryPoint = createPageEntryPoint({
	main: {
		root: JSResourceForInteraction(
			() =>
				import(
					/* webpackChunkName: "async-system-performance-dashboard", jiraSpaEntry: "async-system-performance-dashboard" */ '@atlassian/jira-spa-apps-admin-pages-performance-dashboard'
				),
		),
		getPreloadProps: ({ tenantContext }: EntryPointRouteParams) => {
			const now = new Date();
			const endDate = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
			const startDate = new Date(endDate.getTime() - 7 * 24 * 60 * 60 * 1000);
			return {
				queries: {
					boardPerformanceQuery: {
						parameters: BoardPerformanceTabsQuery,
						variables: {
							cloudId: tenantContext.cloudId,
							startDate,
							endDate,
							filters: [
								{
									boardFilter: {
										keyword: '',
										performanceStatus: ['SLOW', 'MODERATE', 'FAST'],
										sortInput: [
											{
												key: 'perfStatus',
												order: 'DESC',
											},
											{
												key: 'views',
												order: 'DESC',
											},
										],
									},
								},
							],
							after: '',
						},
						fetchPolicy: 'store-or-network',
					},
					performanceNetworkQuery: {
						parameters: PerformanceNetworkViewQuery,
						variables: {
							cloudId: tenantContext.cloudId,
							startDate,
							endDate,
							granularity: 'DAY',
						},
						fetchPolicy: 'store-or-network',
					},
					performanceLimitsAndCleanupQuery: {
						parameters: metricsOverviewQuery,
						variables: {
							cloudId: tenantContext.cloudId,
							schemaMigrationEnabled: fg('site_optimiser_schema_migration'),
							projectLevelReportingEnabled: fg('slt1-682-fe-project-level-reporting-so'),
						},
						options: {
							fetchPolicy: 'network-only',
						},
					},
					performanceOverviewQuery: {
						parameters: PerformanceOverviewQuery,
						variables: {
							cloudId: tenantContext.cloudId,
							startDate,
							endDate,
							granularity: 'DAY',
						},
						fetchPolicy: 'store-or-network',
					},
				},
			};
		},
	},
	topNavigationMenuId: MENU_ID.SETTINGS,
});
